export default {
  loading: '查詢中…', queryFailed: '查詢失敗', notConnected: '尚未連接', addressUnavailable: '尚未取得地址',
  connect: '連接中…', connectMetaMask: '連接 MetaMask', cancel: '取消', close: '關閉', processing: '處理中…',
  confirming: '確認中…', backgroundConfirming: '背景確認中', viewTransaction: '查看交易：{{hash}}',
} as const;

